import React from "react";
import { Loadable, IRouteItem } from "@techzyapp/ui-lib";
import {
  CUSTOMER_GROUPS_ADD_PATH,
  CUSTOMER_GROUPS_PATH,
  CUSTOMER_GROUPS_UPDATE_PATH,
} from "utils/constants/paths";

const CustomerGroups = Loadable(React.lazy(() => import("./View")));
const CustomerGroupsAddOrUpdate = Loadable(
  React.lazy(() => import("./View/AddOrUpdate"))
);

export const CustomerGroupsRoute: IRouteItem = {
  path: CUSTOMER_GROUPS_PATH,
  iconName: "ProfileAdd",
  element: React.createElement(CustomerGroups),
  name: "Customer Groups",
  accessKeys: ["SuperAdmin", "Admin", "Analytics"],
  children: [
    {
      name: "Add / Update",
      path: CUSTOMER_GROUPS_ADD_PATH,
      element: React.createElement(CustomerGroupsAddOrUpdate),
      showInDrawer: false,
    },
    {
      path: CUSTOMER_GROUPS_UPDATE_PATH,
      element: React.createElement(CustomerGroupsAddOrUpdate),
      showInDrawer: false,
    },
  ],
};
